module.exports = __webpack_public_path__ + "static/media/flower.56a36301.svg";